const self = {
  description: {
    initial: undefined,
    label: "Description",
    placeholder: "What is this a model of?",
    maxlength: 2500,
    tooltip: "Describe your model",
  },
  provider: {
    placeholder: "Provider",
    label: "Provider",
    tooltip: "Who created this model?",
    rules: "required",
  },
  license: {
    placeholder: "License",
    label: "License",
    tooltip: "The license of your model",
    rules: "required",
    allowNew: false,
    enum: [
      "MIT",
      "Apache license 2.0",
      "Artistic license 2.0",
      "ISC",
      "Open Software License 3.0",
    ],
    maxlength: 15,
  },
  tags: {
    placeholder: "Tags",
    label: "Tags",
    tooltip: "Keywords that describe your model",
    rules: "",
    allowNew: true,
    maxlength: 15,
  },
  title: {
    initial: undefined,
    label: "Title",
    placeholder: "e.g. Music",
    maxlength: 60,
    tooltip: "The title of your model",
  },
  src: {
    initial: undefined,
    label: "Model Source File",
    placeholder: "Drop your files here or click to upload",
    rules: "required|image|size:4000",
    tooltip: "The image for the front of your model",
  },
};

// Set dependent rules later:
self.description.rules = `max:${self.description.maxlength}`;
self.title.rules = `required|min:2|max:${self.title.maxlength}`;

export default self;
